export const homeTranslations = {
  en: {
    hero: {
      mainTitle: 'Software Engineers',
      subtitle: 'World-class software solutions',
      description: 'Product-focused software development team building professional digital products with the latest AI and Tech innovations. We start with your goals — then choose the right technologies.',
      startProject: 'Start Project',
      riskFree: 'Risk-free start',
      riskFreeDesc: 'You don\'t pay until we deliver your proof of concept',
      stats: {
        experience: 'Years Experience',
        projects: 'Projects Delivered',
        support: 'Support'
      }
    },
    about: {
      title: 'TWO DIRECTIONS, ONE MISSION',
      subtitle: 'DESTA is a company with two powerful directions: a professional software development team that builds products of any complexity, and an Academy that teaches the revolutionary Vibe Coding approach. One mission — in both directions, you get a ready-to-use digital product.',
      features: {
        riskFree: {
          title: 'Risk-Free Development',
          desc: 'You don\'t pay until we deliver your proof of concept.',
          details: 'You don\'t pay until we deliver your proof of concept. We believe in earning your trust through results, not promises. Our risk-free approach means you can explore your ideas without financial commitment upfront. We\'ll create a working prototype that demonstrates the core functionality of your vision, and only when you\'re satisfied with what you see, we move forward with the full development process.'
        },
        ideaToProduct: {
          title: 'Idea to Product',
          desc: 'You just bring your vision, we handle the entire journey.',
          details: 'You just bring your vision, we handle the entire journey from concept to launch. Our team manages every aspect of product development - from initial research and design to development, testing, and deployment. We turn your ideas into market-ready solutions while keeping you involved in every key decision along the way.'
        },
        speedQuality: {
          title: 'Speed & Quality',
          desc: 'We build fast and professionally, using the best modern practices and AI-driven tools.',
          details: 'We build fast and professionally, using the best modern practices and AI-driven tools. Our development process combines agile methodologies with cutting-edge technologies to deliver high-quality software in record time. We leverage automation, AI-powered code generation, and proven frameworks to accelerate development without compromising on quality.'
        },
        security: {
          title: 'Grade Security',
          desc: 'Your product is safe in the hands of experienced security professionals.',
          details: 'Your product is safe in the hands of experienced security professionals. We implement industry-standard security protocols, encryption, and best practices from day one. Our team includes certified security experts who ensure your application meets the highest security standards, protecting your users\' data and your business reputation.'
        },
        scalable: {
          title: 'Scalable by Design',
          desc: 'What we build grows with your business, not against it.',
          details: 'What we build grows with your business, not against it. We architect solutions with scalability in mind, using cloud-native technologies and microservices architecture. Your application will handle increased user loads, feature additions, and business growth seamlessly, saving you from costly rewrites as you expand.'
        },
        cuttingEdge: {
          title: 'Cutting-Edge Expertise',
          desc: 'Top talent — experienced engineers, AI experts and innovators at your service.',
          details: 'Top talent — experienced engineers, AI experts and innovators at your service. Our team consists of seasoned professionals who stay at the forefront of technology trends. We combine deep technical expertise with innovative thinking to deliver solutions that give you a competitive edge in the market.'
        },
        globalVision: {
          title: 'Global Vision',
          desc: 'We collaborate seamlessly across time zones and cultures. International reach — trusted by clients worldwide.',
          details: 'We collaborate seamlessly across time zones and cultures. International reach — trusted by clients worldwide. Our global perspective allows us to understand diverse market needs and deliver solutions that work across different regions and cultures. We have successfully served clients from various countries, building products that scale internationally.'
        },
        partnership: {
          title: 'True Partnership',
          desc: 'We\'re not just coders, we\'re your innovation partners.',
          details: 'We\'re not just coders, we\'re your innovation partners. We become an extension of your team, understanding your business goals and challenges. Our partnership goes beyond development - we provide strategic advice, ongoing support, and help you make technology decisions that drive your business forward.'
        },
        destaAcademy: {
          title: 'Desta Academy',
          desc: 'Learn Vibe Coding — AI writes the code, you design the product as a creator.',
          details: 'Our academy teaches Vibe Coding — a revolutionary approach where AI handles code implementation while you focus on product architecture and design. Learn how to think like an architect, design products from scratch, and use AI as your development partner. Perfect for founders, creators, and developers who want to understand systems thinking.'
        }
      },
      whyWorkWithUs: 'WHY WORK WITH US?',
      cards: {
        aiStack: {
          title: 'AI & Modern Stack',
          quote: 'We use AI as a force multiplier — not as a shortcut.',
          features: [
            'Cloud-native solutions',
            'Scalable by design', 
            'Smart AI integration',
            'Production-ready stacks'
          ]
        },
        partnership: {
          title: 'True Partnership',
          quote: 'We work with you, not for you.',
          features: [
            'End-to-end ownership',
            'Flexible collaboration',
            'Strategic partnership',
            'Long-term mindset',
            'Trusted by international clients'
          ]
        },
        outcomes: {
          title: 'Outcome-Driven',
          quote: 'Your success is the metric we care about.',
          features: [
            'Strategic consulting',
            'Clear communication',
            'Support when it matters',
            'Built for growth'
          ]
        }
      }
    },
    contact: {
      title: 'Ready to start your project?',
      subtitle: 'Contact us in any convenient way, and we will discuss your project',
      contactUs: 'Contact Us',
      quickContact: 'Quick Contact',
      openChat: '💬 Open Chat',
      name: 'Name',
      yourName: 'Your name',
      yourEmail: 'your@email.com',
      projectType: 'Project Type',
      projectTypes: {
        web: 'Web Application',
        mobile: 'Mobile Application', 
        api: 'API Integration',
        scraping: 'Web Scraping',
        ai: 'AI/LLM Solution',
        poc: 'Build a Proof of Concept',
        other: 'Other'
      },
      message: 'Message',
      messagePlaceholder: 'Tell us about your project...',
      sendMessage: 'Send Message',
      sending: 'Sending...',
      successMessage: '✅ Message sent successfully!',
      successDescription: 'Thank you for reaching out! We received your message and will get back to you within 24 hours.',
      errorMessage: '❌ Failed to send message',
      errorDescription: 'Something went wrong. Please try again or contact us directly via email.',
      otherWays: 'Other ways to contact',
      contactDetails: {
        email: {
          title: 'Email Contact',
          details: 'Reach us directly via email for detailed discussions.\n\n📧 desta.academy@gmail.com\n— Academy email for educational programs, Vibe Coding courses, AI Agent Automation, UI/UX Basics and other\n\n📧 desta.development@gmail.com\n— Development team email for custom projects, professional services, and technical consultations\n\nWe typically respond within 24 hours during business days. Email is perfect for:\n\n• Detailed project requirements\n• Educational program inquiries\n• Document sharing\n• Formal communications\n• Technical specifications'
        },
        telegram: {
          title: 'Instagram',
          details: 'Connect with us on Instagram for updates and quick communication.\n\n📸 @desta_development\n— Instagram about DESTA developers team, their services, custom projects, and professional development work\n\n📸 @desta_academy\n— Instagram about Vibe Coding education, AI Agent Automation, Web Scraping creation, and more learning content\n\nInstagram is ideal for:\n\n• Company updates\n• Project showcases\n• Educational content\n• Behind-the-scenes\n• Quick messages\n\nFollow us to stay updated! DM us during business hours (9 AM - 6 PM UTC+2).'
        },
        phone: {
          title: 'Phone Call',
          details: 'Schedule a direct phone call to discuss your project in detail.\n\n🇺🇸 +1 434-825-7923\n🇺🇦 +38 095 852 0575\n\nPhone calls are perfect for:\n\n• Complex project discussions\n• Technical consultations\n• Urgent matters\n• Personal connection\n• Detailed requirements gathering\n\nWe\'re available during business hours (9 AM - 6 PM UTC+2). For international calls, we can also arrange video conferences via Zoom, Google Meet, or Telegram.'
        },
        website: {
          title: 'Visit Our Website',
          details: 'Explore our full portfolio and services on our official website.\n\n🌐 www.desta-company.com\n\nOn our website you can find:\n\n• Complete portfolio of projects\n• Detailed service descriptions\n• Client testimonials\n• Team information\n• Technical blog posts\n• Case studies\n\nThe website provides comprehensive information about our expertise, methodologies, and successful project implementations across various industries.'
        }
      }
    }
  },
  uk: {
    hero: {
      mainTitle: 'Інженери-програмісти',
      subtitle: 'Програмування світового класу',
      description: 'Продуктово-орієнтована команда розробників, що створює професійні цифрові продукти з найновішими AI та Tech інноваціями. Ми починаємо з ваших цілей — потім обираємо правильні технології.',
      startProject: 'Розпочати проект',
      riskFree: 'Старт без ризику',
      riskFreeDesc: 'Ви не платите, поки ми не надамо ваш proof of concept',
      stats: {
        experience: 'Років досвіду',
        projects: 'Проектів завершено',
        support: 'Підтримка'
      }
    },
    about: {
      title: 'ДВА НАПРЯМКИ, ОДНА МІСІЯ',
      subtitle: 'DESTA — це компанія з двома потужними напрямками: професійна команда розробників, що створює продукти будь-якої складності, та Академія, яка навчає революційному підходу Vibe Coding. Одна місія — в обох напрямках ви отримуєте готовий цифровий продукт.',
      features: {
        riskFree: {
          title: 'Розробка без ризику',
          desc: 'Ви не платите, поки ми не надамо ваш proof of concept.',
          details: 'Ви не платите, поки ми не надамо ваш proof of concept. Ми віримо в заслуговування вашої довіри через результати, а не обіцянки. Наш підхід без ризику означає, що ви можете досліджувати свої ідеї без фінансових зобов\'язань наперед. Ми створимо робочий прототип, який демонструє основну функціональність вашого бачення, і тільки коли ви будете задоволені тим, що бачите, ми рухаємося далі з повним процесом розробки.'
        },
        ideaToProduct: {
          title: 'Ідея до продукту',
          desc: 'Ви просто приносите своє бачення, ми обробляємо весь шлях.',
          details: 'Ви просто приносите своє бачення, ми обробляємо весь шлях від концепції до запуску. Наша команда керує кожним аспектом розробки продукту - від початкового дослідження та дизайну до розробки, тестування та розгортання. Ми перетворюємо ваші ідеї на готові до ринку рішення, залучаючи вас до кожного ключового рішення.'
        },
        speedQuality: {
          title: 'Швидкість і якість',
          desc: 'Ми будуємо швидко та професійно, використовуючи найкращі сучасні практики та інструменти на базі ШІ.',
          details: 'Ми будуємо швидко та професійно, використовуючи найкращі сучасні практики та інструменти на базі ШІ. Наш процес розробки поєднує гнучкі методології з передовими технологіями для надання високоякісного програмного забезпечення в рекордні терміни. Ми використовуємо автоматизацію, генерацію коду на базі ШІ та перевірені фреймворки для прискорення розробки без компромісів якості.'
        },
        security: {
          title: 'Корпоративна безпека',
          desc: 'Ваш продукт у безпеці в руках досвідчених фахівців з безпеки.',
          details: 'Ваш продукт у безпеці в руках досвідчених фахівців з безпеки. Ми впроваджуємо галузеві стандарти протоколів безпеки, шифрування та найкращі практики з першого дня. Наша команда включає сертифікованих експертів з безпеки, які забезпечують відповідність вашого додатку найвищим стандартам безпеки, захищаючи дані ваших користувачів та репутацію вашого бізнесу.'
        },
        scalable: {
          title: 'Масштабований дизайн',
          desc: 'Те, що ми будуємо, росте разом з вашим бізнесом, а не проти нього.',
          details: 'Те, що ми будуємо, росте разом з вашим бізнесом, а не проти нього. Ми проектуємо рішення з урахуванням масштабованості, використовуючи хмарні технології та архітектуру мікросервісів. Ваш додаток безпроблемно обробляє збільшене навантаження користувачів, додавання функцій та зростання бізнесу, заощаджуючи вам від дорогого переписування під час розширення.'
        },
        cuttingEdge: {
          title: 'Передова експертиза',
          desc: 'Найкращі таланти — досвідчені інженери, експерти з ШІ та інноватори до ваших послуг.',
          details: 'Найкращі таланти — досвідчені інженери, експерти з ШІ та інноватори до ваших послуг. Наша команда складається з досвідчених професіоналів, які залишаються на передньому краї технологічних трендів. Ми поєднуємо глибоку технічну експертизу з інноваційним мисленням для створення рішень, які дають вам конкурентну перевагу на ринку.'
        },
        globalVision: {
          title: 'Глобальне бачення',
          desc: 'Ми безперешкодно співпрацюємо через часові пояси та культури. Міжнародний охват — довіра клієнтів по всьому світу.',
          details: 'Ми безперешкодно співпрацюємо через часові пояси та культури. Міжнародний охват — довіра клієнтів по всьому світу. Наша глобальна перспектива дозволяє нам розуміти різноманітні потреби ринку та створювати рішення, які працюють у різних регіонах та культурах. Ми успішно обслуговували клієнтів з різних країн, створюючи продукти, які масштабуються міжнародно.'
        },
        partnership: {
          title: 'Справжнє партнерство',
          desc: 'Ми не просто кодери, ми ваші партнери з інновацій.',
          details: 'Ми не просто кодери, ми ваші партнери з інновацій. Ми стаємо продовженням вашої команди, розуміючи ваші бізнес-цілі та виклики. Наше партнерство виходить за межі розробки - ми надаємо стратегічні поради, постійну підтримку та допомагаємо вам приймати технологічні рішення, які рухають ваш бізнес вперед.'
        },
        destaAcademy: {
          title: 'Desta Academy',
          desc: 'Вивчайте Vibe Coding — ШІ пише код, а ви проектуєте продукт як творець.',
          details: 'Наша академія навчає Vibe Coding — революційному підходу, де ШІ займається реалізацією коду, а ви зосереджуєтеся на архітектурі та дизайні продукту. Навчіться мислити як архітектор, проектувати продукти з нуля та використовувати ШІ як вашого партнера з розробки. Ідеально для засновників, творців та розробників, які хочуть зрозуміти системне мислення.'
        }
      },
      whyWorkWithUs: 'ЧОМУ ПРАЦЮВАТИ З НАМИ?',
      cards: {
        aiStack: {
          title: 'ШІ і Сучасний Стек',
          quote: 'Ми використовуємо ШІ як множник сили — а не як скорочення шляху.',
          features: [
            'Хмарні рішення',
            'Масштабований дизайн',
            'Розумна інтеграція ШІ',
            'Готові до продакшну стеки'
          ]
        },
        partnership: {
          title: 'Справжнє Партнерство',
          quote: 'Ми працюємо разом з вами.',
          features: [
            'Повна відповідальність',
            'Гнучка співпраця',
            'Стратегічне партнерство',
            'Довгострокове мислення',
            'Довіра міжнародних клієнтів'
          ]
        },
        outcomes: {
          title: 'Орієнтація на Результат',
          quote: 'Ваш успіх — це метрика, яка нас цікавить.',
          features: [
            'Стратегічне консультування',
            'Прозора комунікація',
            'Підтримка, коли потрібно',
            'Створено для росту'
          ]
        }
      }
    },
    contact: {
      title: 'Готові розпочати ваш проект?',
      subtitle: 'Зв\'яжіться з нами будь-яким зручним способом, і ми обговоримо ваш проект',
      contactUs: 'Зв\'язатися з нами',
      quickContact: 'Швидкий зв\'язок',
      openChat: '💬 Відкрити чат',
      name: 'Ім\'я',
      yourName: 'Ваше ім\'я',
      yourEmail: 'your@email.com',
      projectType: 'Тип проекту',
      projectTypes: {
        web: 'Веб-додаток',
        mobile: 'Мобільний додаток',
        api: 'API інтеграція',
        scraping: 'Веб-скрапінг',
        ai: 'AI/LLM рішення',
        poc: 'Створити Proof of Concept',
        other: 'Інше'
      },
      message: 'Повідомлення',
      messagePlaceholder: 'Розкажіть про ваш проект...',
      sendMessage: 'Надіслати повідомлення',
      sending: 'Відправлення...',
      successMessage: '✅ Повідомлення успішно надіслано!',
      successDescription: 'Дякуємо, що звернулися! Ми отримали ваше повідомлення і відповімо протягом 24 годин.',
      errorMessage: '❌ Не вдалося надіслати повідомлення',
      errorDescription: 'Щось пішло не так. Будь ласка, спробуйте ще раз або зв\'яжіться з нами напряму через email.',
      otherWays: 'Інші способи зв\'язку',
      contactDetails: {
        email: {
          title: 'Електронна пошта',
          details: 'Зв\'яжіться з нами через електронну пошту для детального обговорення.\n\n📧 desta.academy@gmail.com\n— Пошта Академії для освітніх програм, курсів Vibe Coding, AI Agent Automation, UI/UX Basics та іншого\n\n📧 desta.development@gmail.com\n— Пошта команди розробників для кастомних проектів, професійних послуг та технічних консультацій\n\nМи зазвичай відповідаємо протягом 24 годин у робочі дні. Електронна пошта ідеально підходить для:\n\n• Детальних вимог до проекту\n• Запитів щодо освітніх програм\n• Обміну документами\n• Офіційного спілкування\n• Технічних специфікацій'
        },
        telegram: {
          title: 'Instagram',
          details: 'Слідкуйте за нами в Instagram для оновлень та швидкого спілкування.\n\n📸 @desta_development\n— Instagram про команду розробників DESTA, їхні послуги, кастомні проекти та професійну роботу\n\n📸 @desta_academy\n— Instagram про навчання Vibe Coding, AI Agent Automation, створення Web Scraping та інший освітній контент\n\nInstagram ідеально підходить для:\n\n• Оновлень компанії\n• Демонстрації проектів\n• Освітнього контенту\n• Контенту з-за лаштунків\n• Швидких повідомлень\n\nПідписуйтесь! Пишіть у Direct у робочі години (9:00 - 18:00 UTC+2).'
        },
        phone: {
          title: 'Телефонний дзвінок',
          details: 'Запланируйте прямий телефонний дзвінок для детального обговорення вашого проекту.\n\n🇺🇸 +1 434-825-7923\n🇺🇦 +38 095 852 0575\n\nТелефонні дзвінки ідеально підходять для:\n\n• Складних обговорень проекту\n• Технічних консультацій\n• Невідкладних питань\n• Особистого зв\'язку\n• Детального збору вимог\n\nМи доступні в робочі години (9:00 - 18:00 UTC+2). Для міжнародних дзвінків можемо також організувати відеоконференції через Zoom, Google Meet або Telegram.'
        },
        website: {
          title: 'Відвідайте наш сайт',
          details: 'Дослідіть наше повне портфоліо та послуги на офіційному веб-сайті.\n\n🌐 www.desta-company.com\n\nНа нашому сайті ви можете знайти:\n\n• Повне портфоліо проектів\n• Детальні описи послуг\n• Відгуки клієнтів\n• Інформацію про команду\n• Технічний блог\n• Кейси\n\nВеб-сайт надає вичерпну інформацію про нашу експертизу, методології та успішні реалізації проектів у різних галузях.'
        }
      }
    }
  }
};